import {Component, Input, OnInit} from '@angular/core';
import {UserModel} from '../../../auth/models/user.model';
import {CompanyModel} from '../../../auth/models/company.model';
import {JobService} from '../../services/job.service';
import {CandidateModel} from '../../models/candidate.model';
import {finalize} from 'rxjs/operators';
import {RecommandationModel} from '../../models/recommandation.model';

@Component({
  selector: 'app-recommendations',
  templateUrl: './recommendations.component.html',
  styleUrls: ['./recommendations.component.scss']
})
export class RecommendationsComponent implements OnInit {

  @Input() recommendation: RecommandationModel;

  public loading: boolean;

  constructor(
      private jobService: JobService,
  ) { }


  ngOnInit(): void {

  }


}
